import { getStaticUrl } from '@/helpers';
import isOnline from 'is-online';

class StaticUrlService {
  async getFullStaticUrl(radio, route) {
    const online = await isOnline();
    const isElectron = !!localStorage.getItem('isElectron');
    let baseUrl = online || isElectron ? '' : 'http://localhost:8080/';

    return `${baseUrl}${getStaticUrl(radio, route)}`
  }
}

export default new StaticUrlService();
